<template>
    <div class="user">
        <div class="photo">
            <img v-if="me && me.avatar" :src="me.avatar" alt="avatar" />
            <img v-else src="user.png" alt="avatar" />
        </div>
        <div class="user-info">
            <a
                data-toggle="collapse"
                :aria-expanded="!isClosed"
                @click.stop="toggleMenu"
                @click.capture="clicked"
            >
                <span v-if="me">
                    {{ me.name }}
                    <b class="caret"></b>
                </span>
            </a>

            <collapse-transition>
                <div v-show="!isClosed">
                    <ul class="nav">
                        <slot>
                            <!--<li>
                                <router-link :to="'/users/me'">
                                    <span class="sidebar-mini">MP</span>
                                    <span class="sidebar-normal">
                                        Meu Perfil
                                    </span>
                                </router-link>
                            </li>-->
                            <li>
                                <router-link :to="'/lock'">
                                    <span class="sidebar-mini">B</span>
                                    <span class="sidebar-normal">
                                        Bloquear
                                    </span>
                                </router-link>
                            </li>
                            <li>
                                <a @click="logout">
                                    <span class="sidebar-mini">S</span>
                                    <span class="sidebar-normal">Sair</span>
                                </a>
                            </li>
                            <!--
              <li>
                <a href="#vue">
                  <span class="sidebar-mini">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </li>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini">S</span>
                  <span class="sidebar-normal">Settings</span>
                </a>
                            </li>-->
                        </slot>
                    </ul>
                </div>
            </collapse-transition>
        </div>
    </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions'
import { mapState, mapActions } from 'vuex'

export default {
    created() {
        this.getMe()
    },
    computed: {
        ...mapState({
            me: state => state.auth.me
        })
    },
    components: {
        CollapseTransition
    },
    props: {
        title: {
            type: String,
            default: 'Tania Andrew'
        },
        avatar: {
            type: String,
            default: './img/faces/avatar.jpg'
        }
    },
    data() {
        return {
            isClosed: true
        }
    },
    methods: {
        ...mapActions('auth', {
            getMe: 'me',
            logout: 'logout'
        }),
        clicked: function(e) {
            e.preventDefault()
        },
        toggleMenu: function() {
            this.isClosed = !this.isClosed
        }
    }
}
</script>
<style>
.collapsed {
    transition: opacity 1s;
}
</style>
